import { ReactComponent as ErrorBackground } from "../../assets/easyMaps/errorSvg/errorBgMaps.svg";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const ErrorMessageGeral = ({ message }) => {
  const handleRedirect = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="70vh"
      margin="auto"
      textAlign="center"
      flexGrow={1}
    >
      <Box
        width="70%"
        height="70%"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <ErrorBackground style={{ width: "100%", height: "100%" }} />
      </Box>
      <Typography
        sx={{
          fontSize: "1.5em",
          fontWeight: 500,
          marginY: 1,
        }}
      >
        {message}
      </Typography>
      <Box mt={2}>
        <Button
          style={{ textTransform: "initial" }}
          variant="contained"
          color="secondary"
          onClick={handleRedirect}
        >
          Voltar para o início
        </Button>
      </Box>
    </Box>
  );
};

export default ErrorMessageGeral;
